import axios from 'axios';
import { ROOT_URL } from '../globals';

export const CHECK_PASSWORD = 'CHECK_PASSWORD';

export default function checkPassword(uid, password, welcome) {
  const url = `${ROOT_URL}account/CheckPassword?userId=${uid}&password=${password}`;
  axios.get(url)
    .then(response =>  {
        if (response.data.StatusCode === 0) {
          welcome.setState( { passwordFail: false, passwordMsg: '', passwordChecked: true });
      }
      else {
        welcome.setState( { passwordFail: true, passwordMsg: 'Sorry, we couldn\'t find that user or password' });
      }
    })
    .catch (error => {
      console.log(error);
      welcome.setState( { passwordFail: true, passwordMsg: 'Unable to connect at this time' });
    });
}



// WEBPACK FOOTER //
// ./src/api/check_password.js